import Link from "next/link";
import Image from "next/image";
import Badge from "./Badge";
import {
  filterCategorySpecial,
  imageShowSpecialFunction,
  returnUrlTypeCategory,
} from "~/utils/utils";
import { type ArticlePreviewType, type ISSUES } from "~/types";

const PreviewGridLoop = ({ data, categoria, imageShow }) => {
  const article: ArticlePreviewType = data?.articolo;
  const meta = article?.meta;
  const postExcerpt =
    (article?.post_excerpt as string) || (article?.post_content as string);
  const categories = meta ? filterCategorySpecial(meta, categoria) : null;
  const imageShowSpecial = imageShowSpecialFunction(categoria, meta);
  return (
    <article className={`flex w-full flex-col border-b border-gray pb-20`}>
      {article.thumbnail && (
        <figure className="flex pb-8">
          <Link
            href={`/a/${article?.post_name}`}
            className="flex w-full rounded-[50px] bg-lightLightGray"
            prefetch={false}
          >
            {article?.thumbnail != null &&
              ((categoria != "speciale" && imageShow) ||
                (categoria == "speciale" && imageShowSpecial)) && (
                <Image
                  src={article.thumbnail}
                  width={500}
                  height={400}
                  alt={article?.alt || "immagine di copertina"}
                  className="aspect-4/3 w-full rounded-[50px] object-cover mix-blend-multiply hover:opacity-80"
                  sizes="(min-width: 769px) 50vw, (min-width: 1281px) 33vw, 100vw"
                  loading="lazy"
                />
              )}
          </Link>
        </figure>
      )}

      <div className="entry-header flex flex-col gap-6">
        <header className="flex flex-col gap-4">
          <div>
            {categories != null &&
              categories.map((category, index) => (
                <>
                  <Link
                    key={index}
                    className="entry-cat font-bold text-orange hover:underline print:my-2"
                    href={returnUrlTypeCategory(
                      category.slug,
                      category.taxonomy as ISSUES
                    )}
                  >
                    {` ${categoria == "category" ? "BS" : ""} ${category.name}`}
                  </Link>
                  {index < categories.length - 1 && (
                    <span className="text-orange">, </span>
                  )}
                </>
              ))}
          </div>
          <h3 className="mb-2 text-2xl font-light text-black hover:opacity-80 sm:text-4xl md:text-2xl lg:text-4xl print:my-2 print:font-bold">
            <Link
              className="entry-title serif print:my-2"
              href={`/a/${article?.post_name}`}
              dangerouslySetInnerHTML={{ __html: article?.post_title }}
            ></Link>
          </h3>
          {article?.meta != null &&
            article.meta.sottotitolo &&
            article.meta.sottotitolo?.trim().length > 0 && (
              <span className="subtitle block text-xl font-bold !leading-6  sm:text-2xl lg:text-lg print:my-2">
                {article.meta.sottotitolo}
              </span>
            )}
          {article?.meta != null && Boolean(article.meta.autore) && (
            <span className="author block text-lg print:my-2">
              {`di ${article?.meta.autore.replace(/^di /g, "")}`}
            </span>
          )}
          {article?.meta != null && <Badge meta={article?.meta} />}
        </header>
        {postExcerpt?.trim().length > 0 && (
          <div className="entry-summary text-lg text-black sm:text-xl md:text-lg lg:text-xl print:my-2">
            <span
              dangerouslySetInnerHTML={{
                __html: postExcerpt,
              }}
            />
          </div>
        )}
      </div>
    </article>
  );
};

export default PreviewGridLoop;
